import { configure } from 'react-hotkeys';
import config from 'mangools-commons/lib/configs/reactHotkeys';

configure(config);
